module.exports = __webpack_public_path__ + "media/images/icn-L-80e33b45.png";